/**
 * @generated SignedSource<<c68598beb9c697e84e8fb102d9faa763>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StemBalanceResponse",
    "kind": "LinkedField",
    "name": "getBalanceByLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useStemBalanceGetBalanceByLabelQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useStemBalanceGetBalanceByLabelQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "96539d2289c52271eccf7b4cd2595a78",
    "id": null,
    "metadata": {},
    "name": "useStemBalanceGetBalanceByLabelQuery",
    "operationKind": "query",
    "text": "query useStemBalanceGetBalanceByLabelQuery {\n  getBalanceByLabel {\n    balance\n  }\n}\n"
  }
};
})();

node.hash = "042f3d559033df536dab4c7a41b3d2bf";

module.exports = node;
